<div *ngIf="user" class="user-box d-flex align-items-center">
  <img *ngIf="user?.profilePhotoThumbnails?.xsmall" [src]="user?.profilePhotoThumbnails?.xsmall">
  <img *ngIf="!user?.profilePhotoThumbnails?.xsmall" src="assets/images/users/user-dummy-img.jpg">
  <div class="ms-1">
    <p>{{user.name|maskSensitive:2:streamMode}}</p>
    <p>{{user.username|maskSensitive:2:streamMode}}</p>
  </div>
</div>
